export enum MenuManagementTab {
	ZoneTab = 0,
	RoleTab = 1
}